import React from 'react';
import './MissionStatement.css';

const MissionStatement = () => {
  return (
    <div className="mission-statement-container">
      <div className="mission-content">
        <h1 className="mission-title">Mission Statement</h1>
        
        <div className="mission-body">
            <p> 
            Welcome to my website, DANNYTOPIA. A site used to convey as well as build my ultimate utopia. This includes all the things I love: from my family, to my friends, to nature, and to technology. My hope is I can make a 
            place where all of these things can thrive in unison. In delivering content that the people love, I can work towards doing what I love. 

            </p>

            <p> 
            I believe my purpose in my brief lifetime, 
            is to bridge two realms: the Biosphere and the Technosphere. I see their union as a way to create 
            something truly remarkable. Where "sphere" might be talking quite large... quite planetary (the ultimate goal), I am a reasonable guy and seek to create a small example of how they can merge and the beauty that would follow.
            In creating this website alone, I am already making progress by practicing with some pretty cool tech! I have had 
            a truly eye opening experience working on this project. It is fun, and whenever I can find time I will be working on it. Updates will be forever rolling out.
            And yes the content will keep coming. 
            </p> 
            <p> 
            I provide this statement as a rough and preliminary visual of my goal, one that I will refine and clarify as time carries on. Think: rivers, music, green, sunlight, heat, and happiness.
            Every dollar earned here is dedicated to this dream—I can promise you that. 
            Thank you for taking the time to read. Enjoy! 
            </p> 
            <p>
            Below is a painting I made a year ago of my dream life.
            </p>

      
        </div>
        
        <div className="mission-media">
          {/* Fixed image path */}
          <img 
            src="/painting-dream.png" 
            alt="Mission visual representation" 
            className="mission-image"
          />
          
          {/* Alternatively, you could add a video:
          <div className="video-container">
            <iframe
              src="https://www.youtube.com/embed/your-video-id"
              title="Mission Statement Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          */}
        </div>
      </div>
    </div>
  );
};

export default MissionStatement; 